import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, FormInput, Modal, PrimaryButton, toast } from '@systemeio/ui';
import { ErrorResponseContentInterface } from '@systemeio/util';
import { AffiliateWithdrawalTypesEnum } from 'modules/profile/affiliate-settings/enums/affiliate-withdrawal-enum';
import { useWiseRecipientApi } from 'modules/profile/affiliate-settings/hooks/use-wise-recipient-api';
import { AffiliateSettingsInterface, WiseRecipientApiInterface } from 'modules/profile/affiliate-settings/types/affiliate-settings-interface';
import { WiseRecipientDetailsInterface } from 'modules/profile/affiliate-settings/types/wise-details-interface';
import { AdditionalFormFields } from 'modules/profile/affiliate-settings/utils/get-wise-recipient-form';
import React, { useState } from 'react';
import { Loader } from 'shared/components/loader';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { KeyedMutator } from 'swr';
const defaultErrors: ErrorResponseContentInterface = {
  common: [],
  fields: {}
};
interface AddBankDetailsModalProps {
  currency: CurrencyEnum;
  mutateAffiliateSettings: KeyedMutator<AffiliateSettingsInterface>;
}
function AddBankDetailsModal(t0) {
  const $ = _c(64);
  const {
    currency,
    mutateAffiliateSettings
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== currency) {
    t2 = {
      accountHolderName: "",
      currency,
      recipientDetailsType: "",
      details: t1
    };
    $[1] = currency;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [tempState, setTempState] = useState(t2);
  const [formData, setFormData] = useState(null);
  const [errors, setErrors] = useState(defaultErrors);
  const [isFetching, setIsFetching] = useState(false);
  const {
    getDefaultWiseRecipientDetails,
    addWiseRecipientDetails
  } = useWiseRecipientApi(setErrors);
  let t3;
  if ($[3] !== currency || $[4] !== formData || $[5] !== getDefaultWiseRecipientDetails) {
    t3 = async function onModalOpen() {
      if (!formData) {
        ;
        try {
          setIsFetching(true);
          const responseData = await getDefaultWiseRecipientDetails(currency);
          setFormData(responseData);
          setIsFetching(false);
        } catch (t4) {
          setIsFetching(false);
        }
      }
    };
    $[3] = currency;
    $[4] = formData;
    $[5] = getDefaultWiseRecipientDetails;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onModalOpen = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function handleChangeWiseRecipientDetails(key, value) {
      setTempState(prev => ({
        ...prev,
        details: {
          ...prev.details,
          [key]: value
        }
      }));
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleChangeWiseRecipientDetails = t4;
  let t5;
  if ($[8] !== tempState.recipientDetailsType) {
    t5 = function handleChangeRecipientDetailsType(value_0) {
      if (value_0 !== tempState.recipientDetailsType) {
        setTempState(prev_0 => ({
          ...prev_0,
          recipientDetailsType: value_0,
          details: {}
        }));
      }
    };
    $[8] = tempState.recipientDetailsType;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleChangeRecipientDetailsType = t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = function resetFormErrors() {
      setErrors(defaultErrors);
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const resetFormErrors = t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = function updateFormDetails(details) {
      setTempState(prev_1 => ({
        ...prev_1,
        details
      }));
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const updateFormDetails = t7;
  let t8;
  if ($[12] !== addWiseRecipientDetails || $[13] !== mutateAffiliateSettings || $[14] !== t || $[15] !== tempState) {
    t8 = async function handleConfirm() {
      ;
      try {
        setIsFetching(true);
        resetFormErrors();
        const responseData_0 = await addWiseRecipientDetails(tempState);
        await mutateAffiliateSettings(data => {
          if (data) {
            return {
              ...data,
              wiseRecipients: [...data.wiseRecipients, responseData_0],
              withdrawalMethod: AffiliateWithdrawalTypesEnum.bank_transfer
            };
          }
        }, false);
        setIsFetching(false);
        setOpened(false);
        toast.success(t("global.changes_saved"));
      } catch (t9) {
        setIsFetching(false);
      }
    };
    $[12] = addWiseRecipientDetails;
    $[13] = mutateAffiliateSettings;
    $[14] = t;
    $[15] = tempState;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const handleConfirm = t8;
  let t9;
  if ($[17] !== onModalOpen) {
    t9 = () => {
      setOpened(true);
      onModalOpen();
    };
    $[17] = onModalOpen;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("dashboard.user_settings.affiliate_commissions.wire_table.add_bank_details_title");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <div onClick={t9} className="text-brand-primary cursor-pointer">{t10}</div>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setOpened(false);
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t("dashboard.user_settings.affiliate_commissions.wire_table.add_bank_details_title");
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const t14 = tempState.accountHolderName || "";
  let t15;
  if ($[27] !== t) {
    t15 = t("dashboard.user_settings.affiliate_commissions.account_holder_name_title");
    $[27] = t;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = e_1 => setTempState(prev_2 => ({
      ...prev_2,
      accountHolderName: e_1.target.value
    }));
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== errors.fields.accountHolderName) {
    t17 = errors.fields.accountHolderName?.join("");
    $[30] = errors.fields.accountHolderName;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t14 || $[33] !== t15 || $[34] !== t17) {
    t18 = <FormInput value={t14} label={t15} onChange={t16} error={t17} required={true} />;
    $[32] = t14;
    $[33] = t15;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== errors.fields || $[37] !== formData || $[38] !== handleChangeRecipientDetailsType || $[39] !== tempState) {
    t19 = formData ? <AdditionalFormFields formData={formData} setFormData={setFormData} state={tempState} onChangeDetails={handleChangeWiseRecipientDetails} onChangeRecipientDetailsType={handleChangeRecipientDetailsType} fieldErrors={errors.fields} resetFormErrors={resetFormErrors} updateFormDetails={updateFormDetails} /> : <div className="flex justify-center"><Loader /></div>;
    $[36] = errors.fields;
    $[37] = formData;
    $[38] = handleChangeRecipientDetailsType;
    $[39] = tempState;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== errors.common) {
    t20 = errors.common && <>{errors.common.map(_temp)}</>;
    $[41] = errors.common;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t18 || $[44] !== t19 || $[45] !== t20) {
    t21 = <div className="flex flex-col justify-center gap-3">{t18}{t19}{t20}</div>;
    $[43] = t18;
    $[44] = t19;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  const t22 = !formData || isFetching;
  let t23;
  if ($[47] !== t) {
    t23 = t("global.save");
    $[47] = t;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== handleConfirm || $[50] !== t22 || $[51] !== t23) {
    t24 = <div className="flex justify-center gap-4"><PrimaryButton type="button" onClick={handleConfirm} disabled={t22}>{t23}</PrimaryButton></div>;
    $[49] = handleConfirm;
    $[50] = t22;
    $[51] = t23;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== t21 || $[54] !== t24) {
    t25 = <form className="flex flex-col gap-6 lg:gap-10">{t21}{t24}</form>;
    $[53] = t21;
    $[54] = t24;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== isFetching || $[57] !== opened || $[58] !== t13 || $[59] !== t25) {
    t26 = <Modal isFetching={isFetching} opened={opened} onClose={t12} title={t13}>{t25}</Modal>;
    $[56] = isFetching;
    $[57] = opened;
    $[58] = t13;
    $[59] = t25;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== t11 || $[62] !== t26) {
    t27 = <>{t11}{t26}</>;
    $[61] = t11;
    $[62] = t26;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  return t27;
}
function _temp(error, index) {
  return <p className="text-red px-6 text-center text-sm" key={index}>{error}</p>;
}
export default AddBankDetailsModal;